'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var EventStore = require('orbit-db-eventstore');

var FeedIndex = require('./FeedIndex');

var FeedStore = /*#__PURE__*/function (_EventStore) {
  _inherits(FeedStore, _EventStore);

  var _super = _createSuper(FeedStore);

  function FeedStore(ipfs, id, dbname, options) {
    var _this;

    _classCallCheck(this, FeedStore);

    if (!options) options = {};
    if (!options.Index) Object.assign(options, {
      Index: FeedIndex
    });
    _this = _super.call(this, ipfs, id, dbname, options);
    _this._type = 'feed';
    return _this;
  }

  _createClass(FeedStore, [{
    key: "remove",
    value: function remove(hash) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.del(hash, options);
    }
  }, {
    key: "del",
    value: function del(hash) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var operation = {
        op: 'DEL',
        key: null,
        value: hash
      };
      return this._addOperation(operation, options);
    }
  }]);

  return FeedStore;
}(EventStore);

module.exports = FeedStore;